export default "__VITE_ASSET__bf3d300e__"